import React from "react";

type Props = {
  icon: React.ReactNode;
  backgroundColor: string;
  className?: string;
};

function IconBackground({ icon, backgroundColor, className }: Props) {
  return (
    <div
      className={`${backgroundColor} h-10 w-10 rounded-md justify-center flex items-center ${className} `}
    >
      {icon}
    </div>
  );
}

export default IconBackground;
